import React, {Component} from 'react';
import './list.css';
import Constant from "./constant.js"
import {getZykPictureList, changZykPictureCount, getAnalyze} from '../../actions'
import {List, Pagination, Spin} from "antd";
import {connect} from "react-redux";
import $ from 'jquery'
import {HEADER_HEIGHT} from "../../constants";
import {applicationName} from "../../utils";

class PictureList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            count: 0,
            page: 1,
            size: Constant.configPagesize,
            start: 1,
            loading: false,
            height: applicationName() === 'pms' ? window.innerHeight - HEADER_HEIGHT - 172 : window.innerHeight - HEADER_HEIGHT - 272,
        }
    }

    // 在组件即将被挂载到页面的时刻执行
    componentWillMount() {
        this.setState({
            loading: true,
        });
        //请求后台获取图片的列表数据
        let onlyMe = 1;
        if (this.props.onlyMe) {
            onlyMe = 0
        }
        let param = {
            "query": this.props.searchText,
            "isAll": onlyMe,
            "start": this.state.page,
            "size": this.state.size,
        };
        getZykPictureList(param, this.updatePictureList.bind(this));
    }

    updatePictureList(result) {
        //传递总数
        this.props.changZykPictureCount(result.count);

        //处理前台分页数据
        let resultData = result.data;

        this.setState({
            data: resultData,
            loading: false,
            count: result.count
        });


    }


    /**
     * 图片预览功能
     * @param record
     */
    imageTopreview(record) {

        let data = {
            "pictureList": [{
                "path": record.ZykPicture_path,
                "desc": record.ZykPicture_name
            }
            ],
            "title": record.ZykPicture_name
        };

        let parent;
        if (applicationName() === 'pms') {
            parent = window.parent;
        } else {
            parent = window.frames[0];
        }

        parent.layui.config({
            base: '/cm-sites/layuiadmin/modules/' //静态资源所在路径
        }).extend({
            index: 'lib/index' //主入口模块
        }).use(['storage'], function () {
            let content = '/cm-sites/'+window.env+'/previewMedia/atlas-view.html';
            var storage = parent.layui.storage;
            storage.set("current-atlas", data);

            parent.layer.open({
                type: 2,
                area: ['800px', '600px'],
                title: data.title,
                content: content
            });
        });
    }


    insertPicture(data) {

        //contribute和pms使用的编辑器不一样，所以调用的方法也不一样
        if (applicationName() === 'contribute') {
            let param = {
                "alt": data.ZykPicture_name,
                "floatStyle": "",
                "src": data.ZykPicture_path,
                "width": 500,
                // "height":data.ZykPicture_imageHeight,
                "title": "",
                "_src": data.ZykPicture_path
            }
            let list = []
            list.push(param);
            window.frames[0].ueditor.execCommand('insertimage', list);

            let param2 = {
                "success": true,
                "url": data.ZykPicture_path,
                "smallUrl": data.ZykPicture_path,
                "middleUrl": data.ZykPicture_path,
                "storageFile": {
                    "_id": "",
                    "duration": 0,
                    "height": data.ZykPicture_imageHeight,
                    "md5": "",
                    "name": data.ZykPicture_name,
                    "path": data.ZykPicture_path,
                    "prefix": "",
                    "size": 0,
                    "storageDirectoryId": [],
                    "suffix": data.ZykPicture_ext,
                    "type": 1,
                    "url": "",
                    "width": 500
                },
                "state": "",
                "title": "",
                "original": data.ZykPicture_name,
            }
            window.frames[0].cmSitesFileUploadAfterCallbackFun(param2);
        } else {
            let param = {
                "alt": data.ZykPicture_name,
                "floatStyle": "",
                "src": data.ZykPicture_path,
                "title": "",
                "_src": data.ZykPicture_path,
                "width": 500,
                "border": "0",
                "vspace": "0"
            }
            let list = []
            list.push(param);
            window.parent.ueditor.execCommand('insertimage', list);

            let param2 = {
                "success": true,
                "url": data.ZykPicture_path,
                "smallUrl": data.ZykPicture_path,
                "middleUrl": data.ZykPicture_path,
                "storageFile": {
                    "_id": "",
                    "duration": 0,
                    "height": data.ZykPicture_imageHeight,
                    "md5": "",
                    "name": data.ZykPicture_name,
                    "path": data.ZykPicture_path,
                    "prefix": "",
                    "size": 0,
                    "storageDirectoryId": [],
                    "suffix": data.ZykPicture_ext,
                    "type": 1,
                    "url": "",
                    "width": 500
                },
                "state": "",
                "title": "",
                "original": data.ZykPicture_name,
            }
            window.parent.cmSitesFileUploadAfterCallbackFun(param2);
        }
    }


    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.tableKey === 2) {
            this.setState({
                loading: true,
                start: 1,
            })

            let onlyMe = 1;
            if (nextProps.onlyMe) {
                onlyMe = 0
            }
            let param = {
                "query": nextProps.searchText,
                "isAll": onlyMe,
                "start": 1,
                "size": this.state.size,
            };
            //请求后台获取稿件列表数据
            getZykPictureList(param, this.updatePictureList.bind(this));
        }
    }


    addHoverRemark() {
        $(".pictureList").on('mouseenter', '.image-box', function () {
            $(this).find(".image-remake").animate({bottom: "0px"}, 300);
        })

        $(".pictureList").on('mouseleave', '.image-box', function () {
            $(this).find(".image-remake").animate({bottom: "-35px"}, 300);
        });
    }

    getZykPicturePageList(page, pageSize) {
        this.setState({
            loading: true,
        })

        let onlyMe = 1;
        if (this.props.onlyMe) {
            onlyMe = 0
        }

        this.setState({
            start: page
        })

        let param = {
            "query": this.props.searchText,
            "isAll": onlyMe,
            "start": page,
            "size": pageSize,
        };
        //请求后台获取图片列表数据
        getZykPictureList(param, this.updatePictureList.bind(this));
    }


    /**
     * 分词在页面高亮显示；
     * @param data
     */
    lightAnayWorldInList(data) {
        //按照优先级排序
        let listData = data.sort(function (a, b) {
            return b.length - a.length
        });
        // for(var i=0;i<data.length;i++){
        //定义正则表达式对象  array[i]是关键字   "g"是指全局范围
        let a = new RegExp(listData.join("|"), "g");
        $(".content-header").each(function () {
            var html = $(this)[0].getAttribute('title')
            html = html.replace(a, function (item) {
                return "<span style='color:#F00'>" + item + "</span>"
            });
            $(this).html(html);
        });
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.tableKey === 2) {
            console.info("picture_list");
            //分词处理，分词高亮显示；
            if (this.props.searchText) {
                let param = {
                    str: this.props.searchText
                };
                //请求后台获取分词数据
                getAnalyze(param, this.lightAnayWorldInList.bind(this));
            }else {
                $(".content-header").each(function () {
                    if ($(this).find('span')[0] && $(this).find('span')[0].style) {
                        $(this).find('span')[0].style.color = '#000';
                    }
                });
            }
        }
    }

    componentDidMount() {
        this.addHoverRemark();
    }


    //高亮显示，搜索


    render() {
        return (
            <Spin spinning={this.state.loading}>
                <div className='pictureList' style={{height: this.state.height + 'px', overflow: "auto"}}>
                    <List
                        itemLayout="vertical"
                        size="large"
                        dataSource={this.state.data}
                        renderItem={item => (
                            <List.Item>
                                <List.Item.Meta
                                    // avatar={<Avatar src={item.avatar} />}
                                    title={<div className="item-box">
                                        <div className="image-box" onClick={() => {
                                            this.insertPicture(item)
                                        }}>
                                            <img src={item.ZykPicture_path}/>
                                            <div className="image-remake">
                                                插入正文
                                            </div>
                                        </div>
                                        <div className={"content-box content-box-" + applicationName()}>
                                            <p className={"content-header image-name" + applicationName()}
                                               title={item.ZykPicture_name}>{item.ZykPicture_name}</p>
                                            <p className="content-img-size"><span style={{cursor:'pointer',color:"#0050B3"}}
                                                onClick={this.imageTopreview.bind(this, item)}>预览  </span>{item.ZykPicture_imageWidth}*{item.ZykPicture_imageHeight}
                                            </p>
                                            <p className="content-bottom">
                                                <span
                                                    className='zykresource'>来源:{Constant.getDataSource(item.ZykPicture_dataSource)}</span>
                                                <span className='zykdate' title={item.ZykPicture_createDate}>日期:{item.ZykPicture_createDate}</span>
                                            </p>
                                        </div>
                                    </div>}
                                />
                            </List.Item>
                        )}
                    />
                </div>
                <div className='pageTables'>
                    <Pagination current={this.state.start} showLessItems={true} total={this.state.count}
                                defaultPageSize={this.state.size}
                                defaultCurrent={1}
                                onChange={(page, pageSize) => {
                                    this.getZykPicturePageList(page, pageSize)
                                }} onShowSizeChange={(page, pageSize) => {
                        this.getZykPicturePageList(page, pageSize)
                    }}/>
                </div>
            </Spin>

        );
    }
}

function mapStateToProps(state) {
    return {
        searchText: state.zykReducer.searchText,
        onlyMe: state.zykReducer.onlyMe,
        tableKey: state.zykReducer.tableKey,
        doSearch: state.zykReducer.doSearch
    }
}


function mapStateToMethod(dispatch) {
    return {
        changZykPictureCount: function (zykPictureCount) {
            return dispatch(changZykPictureCount(zykPictureCount));
        }
    }
}

export default connect(mapStateToProps, mapStateToMethod)(PictureList);
